export default {
  title: 'Detalii preț',
  subtotal: 'Subtotal',
  method_fee: 'Taxă de livrare',
  tip: 'Bacșiș',
  service_fee: 'Procesare online',
  payment_method_upcharge_fee: 'Taxă PayPal',
  discount: 'Reducere',
  taxes: 'Taxe',
  total: 'Total',
};
